import React from 'react';
import classNames from 'classnames';

const MainFilterSmall = (props) => {
  const {
    id,
    icon,
    label,
    value,
    placeholder,
    changed,
    onClearClick,
    openFilter,
    isOpen,
    showClearButton
  } = props;

  return (
    <div
        className={classNames("main-filter__selection", {
          'main-filter__selection--active': showClearButton || isOpen,
        })}
        onClick={openFilter}
        onKeyDown={openFilter}
        role="menuitem"
        id={id}
      >
        {changed && (
          <span
            className="main-filter__clear icon-close"
            onClick={onClearClick}
          />
        )}
        <span className="main-filter__selection-label">{label}</span>
        <div className="main-filter__selection-outer-wrap">
          <i className={`${icon} main-filter__selection-icon`} />
          <div className="main-filter__selection-value">
            {value
              ? value
              : <span className="placeholder">{placeholder}</span>
            }
          </div>
        </div>
        <div className="main-filter__mobile">
          <i
            className={classNames(`${icon} main-filter__selection-icon`, {
              'main-filter__selection-icon--active': changed,
            })}
          />
        </div>
      </div>
  )
}

export default React.memo(MainFilterSmall);
